import { useContext } from 'react';

import { CommunicationBridgeContext } from 'features/communication-bridge/CommunicationBridgeProvider';
import { normalizeLanguageType } from 'store/ui/i18n/normalizeLanguageType';
import { LanguageType, StorageKeys } from 'types/index';

/**
 * Returns the current UI language.
 *
 * The shell app owns the language and pushes it down via the communication
 * bridge, which holds it as React state so consumers re-render when it
 * changes. When rendered outside the bridge (e.g. tests), we fall back to the
 * value persisted in localStorage.
 */
export const useLanguage = (): LanguageType => {
	const context = useContext(CommunicationBridgeContext);

	if (context) return context.language;

	return normalizeLanguageType(localStorage.getItem(StorageKeys.UserLanguage));
};
